import React from 'react';
import './root-view.less';
// 预留商城公共头部组件：import Header from './components/header';

function Template({ Component }) {
  return <Component />;
}

export default Template;
